export const DESTAQUE_TABS = [
  { key: "Banner", label: "Banners" },
  { key: "Lookbook", label: "Lookbooks" },
  { key: "Video", label: "Vídeos" },
  { key: "Material", label: "Materiais" },
  { key: "Campanha", label: "Campanhas" },
];

export const TIPO_FILTERS = [
  { value: "Banner", label: "Banner" },
  { value: "Video", label: "Vídeo" },
  { value: "MaterialPdf", label: "PDF" },
  { value: "Lookbook", label: "Lookbook" },
  { value: "Campanha", label: "Campanha" },
];

export const SORT_OPTIONS = [
  { value: "recentes", label: "Mais recentes" },
  { value: "downloads", label: "Mais baixados" },
];

export const INITIAL_FILTERS = {
  tipos: [],
  categorias: [],
  campanhas: [],
  apenasAtivos: true,
  apenasFavoritos: false,
  ordenacao: "recentes",
};
